// Check document ready state and initialize appropriately
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initDownloadButtons)
} else {
    initDownloadButtons()
}

// Function to initialize the download buttons logic
function initDownloadButtons() {
    let buttonsDownload = document.querySelectorAll(".download-button")

    // Exit early if no download buttons are found
    if (!buttonsDownload.length) return

    // Process each download button
    buttonsDownload.forEach((button) => {
        let linkElement = button.querySelector("a")

        // Ensure the link exists and has an href attribute
        if (linkElement) {
            let url = linkElement.getAttribute("href")
            if (url) {
                // Extract the file name from the URL and set it as the download attribute
                let downloadFilename = url.substring(url.lastIndexOf("/") + 1)
                linkElement.setAttribute("download", downloadFilename)
                
                // Add click event listener to track downloads
                linkElement.addEventListener("click", async function(e) {
                    try {
                        // Track the download via API call
                        await fetch("/paining-app/help-image-download", {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]')?.getAttribute("content") || "",
                            },
                        })
                    } catch (error) {
                        console.error("Error tracking help image download:", error)
                    }
                })
            }
        }
    })
}
